module.exports = __webpack_public_path__ + "media/src/StayPackage/images/clock-ef7fabc9e796188030e960c69a593b36.svg";